<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M9 4.5h11l3.5 6.5v5.5h-2.55a2.5 2.5 0 00-4.9 0h-6.1A2.503 2.503 0 008 14.55c-2-.35-2.9 1.2-3 1.95H.5V11l5-1.5 3.5-5z"/>
  <path stroke="#000" d="M10 17a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM21 17a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"/>
</svg>
